// @ts-nocheck
import { call, put, takeLatest } from 'redux-saga/effects';
import { errorToast, successToast } from 'utils/toastHandler';
import {
  createCategory,
  getCategories,
  updateCategory,
  deleteCategory,
  createNote,
  updateNote,
  deleteNote,
} from '../services/category';
import categoryActions, { Types } from '../actions/category';

function* createCategoryRequest(action) {
  try {
    const { payload, data } = action;
    const response = yield call(createCategory, payload);

    yield put(categoryActions.createCategorySuccess({ data: response.data }));

    if (!data.shouldCreateAnother) {
      yield put(categoryActions.closeCategoryDrawer());
    }

    yield put(categoryActions.resetFormFields());
    successToast('Category Created Successfully');
  } catch (error) {
    yield put(categoryActions.createCategoryFailure());
    error?.response?.data?.error && errorToast(error.response.data.error);
  }
}

function* getCategoriesRequest(action) {
  try {
    const { params } = action;
    const response = yield call(getCategories, params);
    yield put(categoryActions.getCategoriesSuccess(response.data));
  } catch (error) {
    yield put(categoryActions.getCategoriesFailure());
  }
}

function* updateCategoryRequest(action) {
  try {
    const { params, payload } = action;
    const response = yield call(updateCategory, params, payload);
    yield put(categoryActions.updateCategorySuccess({ data: response.data }));
    yield put(categoryActions.closeCategoryDrawer());
    yield put(categoryActions.resetFormFields());
    successToast('Category updated Successfully');
  } catch (error) {
    yield put(categoryActions.updateCategoryFailure());
    error?.response?.data?.error && errorToast(error.response.data.error);
  }
}

function* deleteCategoryRequest(action) {
  try {
    const { params } = action;
    yield call(deleteCategory, params);
    yield put(categoryActions.deleteCategorySuccess(params));
    yield put(categoryActions.closeConfirmationModal());
    successToast('Category Deleted Successfully');
  } catch (error) {
    yield put(categoryActions.deleteCategoryFailure());
    error?.response?.data?.error && errorToast(error.response.data.error);
  }
}

function* createSubCategoryRequest(action) {
  try {
    const { payload, data } = action;
    const response = yield call(createCategory, payload);
    yield put(
      categoryActions.createSubCategorySuccess({ data: response.data }),
    );
    if (!data.shouldCreateAnother) {
      yield put(categoryActions.closeSubCategoryDrawer());
    }
    yield put(categoryActions.resetSubCategoryFormFields(data));
    successToast('Sub Category Created Successfully');
  } catch (error) {
    yield put(categoryActions.createSubCategoryFailure());
    error?.response?.data?.error && errorToast(error.response.data.error);
  }
}

function* updateSubCategoryRequest(action) {
  try {
    const { params, payload } = action;
    const response = yield call(updateCategory, params, payload);

    yield put(
      categoryActions.updateSubCategorySuccess({ data: response.data }),
    );
    yield put(categoryActions.closeSubCategoryDrawer());
    yield put(
      categoryActions.resetSubCategoryFormFields({
        shouldCreateAnother: false,
      }),
    );
    successToast('Sub Category updated Successfully');
  } catch (error) {
    yield put(categoryActions.updateSubCategoryFailure());
    error?.response?.data?.error && errorToast(error.response.data.error);
  }
}

function* deleteSubCategoryRequest(action) {
  try {
    const { params } = action;
    yield call(deleteCategory, params);
    yield put(categoryActions.deleteSubCategorySuccess(params));
    yield put(categoryActions.closeConfirmationModal());
    successToast('Sub Category deleted Successfully');
  } catch (error) {
    yield put(categoryActions.deleteSubCategoryFailure());
    error?.response?.data?.error && errorToast(error.response.data.error);
  }
}

function* createNoteRequest(action) {
  try {
    const { payload } = action;
    const response = yield call(createNote, payload);

    yield put(categoryActions.createNoteSuccess({ data: response.data }));
    yield put(categoryActions.closeNoteModal());
  } catch (error) {
    yield put(categoryActions.createNoteFailure());
    error?.response?.data?.error && errorToast(error.response.data.error);
  }
}

function* updateNoteRequest(action) {
  try {
    const { params, payload } = action;
    const response = yield call(updateNote, params, payload);

    yield put(categoryActions.updateNoteSuccess({ data: response.data }));
    yield put(categoryActions.closeNoteModal());
  } catch (error) {
    yield put(categoryActions.updateNoteFailure());
    error?.response?.data?.error && errorToast(error.response.data.error);
  }
}

function* deleteNoteRequest(action) {
  try {
    const { params } = action;
    yield call(deleteNote, params);
    yield put(categoryActions.deleteNoteSuccess(params));
  } catch (error) {
    yield put(categoryActions.deleteNoteFailure());
    error?.response?.data?.error && errorToast(error.response.data.error);
  }
}

function* categoryWatcher() {
  yield takeLatest(Types.CREATE_CATEGORY_REQUEST, createCategoryRequest);
  yield takeLatest(Types.GET_CATEGORIES_REQUEST, getCategoriesRequest);
  yield takeLatest(Types.UPDATE_CATEGORY_REQUEST, updateCategoryRequest);
  yield takeLatest(Types.DELETE_CATEGORY_REQUEST, deleteCategoryRequest);
  yield takeLatest(Types.CREATE_SUB_CATEGORY_REQUEST, createSubCategoryRequest);
  yield takeLatest(Types.UPDATE_SUB_CATEGORY_REQUEST, updateSubCategoryRequest);
  yield takeLatest(Types.DELETE_SUB_CATEGORY_REQUEST, deleteSubCategoryRequest);
  yield takeLatest(Types.CREATE_NOTE_REQUEST, createNoteRequest);
  yield takeLatest(Types.UPDATE_NOTE_REQUEST, updateNoteRequest);
  yield takeLatest(Types.DELETE_NOTE_REQUEST, deleteNoteRequest);
}

export default categoryWatcher;
